import { h } from 'preact';
import clsx from 'clsx';
import { useState } from 'preact/hooks';
import Chevron from 'utils/icon/icon-chevron-right.svg';
import ChevronDown from 'utils/icon/icon-chevron-down.svg';
import CategorySlider from './category-slider';

const RecommendedCategories = ({ data }) => {
  const { blocks } = data;
  const [activeTab, setActiveTab] = useState(0);

  if (!blocks.length) return null;

  const formattedBlocks = blocks
    .reduce((acc, block) => {
      if (!acc[block.index]) {
        acc[block.index] = {
          title: block.title,
          collections: [],
        };
      }
      acc[block.index].collections = [
        ...acc[block.index].collections,
        block?.collection,
      ];
      return acc;
    }, [])
    .filter((el) => el != null);

  return (
    <div className="overflow-x-hidden relative pb-32">
      <div className="container !flex flex-col relative">
        {data?.title && (
          <div className="text-center display-2 pt-32">{data.title}</div>
        )}
      </div>
      <div
        className={clsx('container !flex flex-col relative pt-32', {
          'pb-32': blocks.some((block) => block.title),
        })}
      >
        <div className="flex justify-center items-center gap-32">
          {formattedBlocks.map(
            (block, index) =>
              block.collections.length > 0 && (
                <button
                  className={clsx(
                    'flex flex-col justify-center items-center body-1-semibold uppercase underline-offset-4 hover:underline',
                    {
                      underline: activeTab === index,
                    },
                  )}
                  onClick={() => setActiveTab(index)}
                  key={index}
                >
                  {block.title}
                </button>
              ),
          )}
        </div>
        <div
          className={clsx(
            'hidden absolute tablet:right-56 top-1/2 -translate-y-1/2 gap-4 tablet:flex items-center',
            {
              hidden: blocks[activeTab].collections?.length < 6,
              'tablet:flex items-center':
                blocks[activeTab].collections?.length > 6,
            },
          )}
        >
          <button
            role="button"
            className="category-slider-arrows prev w-32 h-32 lc:rounded-full lc:border lc:border-grey-900 inline-flex items-center justify-center lc:disabled:border-grey-400 group"
          >
            <Chevron className="ml:hidden w-16 h-16 ml:w-24 ml:h-24 right-1 ml:right-auto -rotate-180 relative lc:group-disabled:text-disabled" />
            <ChevronDown className="lc:hidden w-24 h-24 right-auto  relative rotate-90 group-disabled:text-disabled" />
          </button>
          <button
            role="button"
            className="category-slider-arrows next w-32 h-32 lc:rounded-full lc:border lc:border-grey-900 inline-flex items-center justify-center lc:disabled:border-grey-400 group"
          >
            <Chevron className="ml:hidden w-16 h-16 ml:w-24 ml:h-24 left-1 ml:left-auto relative lc:group-disabled:text-disabled" />
            <ChevronDown className="lc:hidden w-24 h-24 left-auto relative -rotate-90 group-disabled:text-disabled" />
          </button>
        </div>
      </div>
      <CategorySlider collections={formattedBlocks[activeTab].collections} />
    </div>
  );
};

export default RecommendedCategories;
